<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="modal-card container-modal-confirm-submit">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <p class="modal-card-title is-size-5 has-text-centered">
        {{ General.WARNING }}
      </p>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container has-text-color-7">
      <b
        v-if="isAutoSubmit"
        class="spacing-px-20 py-10"
        v-html="`${General.MESSAGES.WARNING_AUTO_PROCESS}?`"
      />
      <b v-else class="spacing-px-20 pt-10">{{
        General.MESSAGES.ARE_YOU_SURE_YOU_WANT_SUBMIT_PROCESS
      }}</b>
      <div class="spacing-px-20">
        <div>
          <p class="has-text-weight-semibold">{{ General.SUBJECT }}</p>
          <p>
            {{ getSubject }}
          </p>
        </div>
        <div v-if="process.observation" class="mt-5">
          <p class="has-text-weight-semibold">{{ General.NOTES }}</p>
          <p>
            {{ process.observation }}
          </p>
        </div>
        <div class="py-5">
          <p class="has-text-weight-semibold">{{ General.TO }}</p>
          <p v-for="(to, index) in getTo" :key="index">
            <span class="has-text-weight-semibold">{{ to.part }}</span
            >{{ to.capacity }}
          </p>
        </div>
        <div>
          <p class="has-text-weight-semibold">{{ General.INTERESTED }}</p>
          <p>
            <span v-for="(cc, index) in getCC" :key="index">
              {{ cc }}
              <br />
            </span>
            <span v-if="!getCC.length">
              {{ getUserCapacity }}
            </span>
          </p>
        </div>
        <p class="mt-10 has-text-weight-semibold">
          {{ General.MESSAGES.EMAIL_SEND }}
        </p>
      </div>
      <footer class="modal-card-foot is-align-self-flex-end">
        <div class="buttons">
          <b-button
            data-cy="SUBMIT_CONFIRM"
            :type="isContrast ? 'is-white-dark' : 'is-green-lawn'"
            size="is-medium"
            @click="confirmAction"
          >
            {{ isAutoSubmit ? General.AUTO_PROCESS : General.PROCEED }}
          </b-button>
          <b-button
            data-cy="SUBMIT_CANCEL"
            :type="isContrast ? 'is-white-dark' : 'is-warning'"
            size="is-medium"
            outlined
            @click="close"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalConfirmSubmit",

  props: {
    process: {
      required: true,
      type: Object
    },
    confirm: {
      type: Function,
      default: () => null
    },
    isAutoSubmit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      subjects: "getSubjects",
      getCapacityById: "getCapacityById",
      isContrast: "isContrast"
    }),

    getSubject() {
      const id = this.process.subject;
      const subject = this.subjects.find(subject => subject.id === id);
      return `${subject.code} - ${subject.name
        .toLowerCase()
        .split(" - ")
        .map(partName => `${partName[0].toUpperCase()}${partName.slice(1)}`)
        .join(" - ")}`;
    },

    getTo() {
      const list = this.process.draft_to;
      return list.map((capacity, index) => ({
        part: capacity.entity.abbreviation,
        capacity: `/${
          capacity.abbreviation.includes("/")
            ? capacity.abbreviation.split("/")[1]
            : capacity.abbreviation
        } - ${capacity?.description}
            ${this.getListSeparator(index, list.length)}`
      }));
    },

    getCC() {
      const list = this.process.cc;
      return list.map(
        (cc, index) =>
          `${cc.user_name || cc.abbreviation}${
            cc.user_cpf ? ` - ${cc.user_cpf}` : ` - ${cc.description}`
          }${this.getListSeparator(index, list.length)}`
      );
    },

    getUserCapacity() {
      const capacityOrigin = this.getCapacityById(this.process.origin);
      if (!capacityOrigin) return "";
      return `${capacityOrigin?.entity.abbreviation}/${
        capacityOrigin?.abbreviation.includes("/")
          ? capacityOrigin?.abbreviation.split("/")[1]
          : capacityOrigin?.abbreviation
      } - ${capacityOrigin?.description}`;
    }
  },

  methods: {
    async confirmAction() {
      this.isLoading = true;
      await this.confirm();
      this.isLoading = false;
      this.close();
    },

    close() {
      this.$parent.close();
    },

    getListSeparator(index, listLength) {
      if (listLength - index == 1) return "";
      else if (listLength - index == 2) return " e";
      else return ",";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
</style>
<style lang="scss">
@import "@/assets/scss/variables";
.container-modal-confirm-submit .custom-color-green {
  color: $green-lawn;
}
</style>
